import React from 'react';
import { Form, Input, Button, message } from 'antd';
import { ServicetypeService } from '../../../Services/Manage/ServicetypeService';
import useMessage from 'antd/es/message/useMessage';
import { UserService } from '../../../Services/Manage/UserService';

const AddServiceType = ({ initialValues, onSubmit, onCancel }) => {
    const [form] = Form.useForm();
    const [message, messagecontxt] = useMessage();

    const handleFinish = async (values) => {
        try {

            const user = await UserService.getOmeUser();
            const payload = { ...values, added_by: user.uid };

            if (initialValues?.id) {
                console.log(initialValues);

                const req = await ServicetypeService.updateServicesType(payload, initialValues.id,);
                console.log(req);

                if (req.status) {
                    message.success(req.message)
                    onSubmit(values);
                    form.resetFields();
                } else {
                    message.error(req.message)
                }

            } else {
                const req = await ServicetypeService.createServicesType(payload);
                console.log(req);
                if (req.status) {
                    message.success(req.message)
                    onSubmit(payload);
                    form.resetFields();
                } else {
                    message.error(req.message)
                }
            }


        } catch (error) {
            console.error("Service operation failed:", error);
        }
    };
    return (
        <Form
            form={form}
            layout="vertical"
            initialValues={initialValues || {}}
            onFinish={handleFinish}
        >
            <Form.Item
                name="type_name"
                label="Service Type Name"
                rules={[{ required: true, message: 'Please enter service type name' }]}
            >
                <Input size='large' />
            </Form.Item>

            <Form.Item
                name="type_code"
                label="Service Type Code"
                rules={[{ required: true, message: 'Please enter service type code' }]}
            >
                <Input size='large' />
            </Form.Item>

            <Form.Item name="note" label="Note">
                <Input.TextArea rows={3} size='large' />
            </Form.Item>

            {/* <Form.Item name="added_by" label="Added By">
                <Input size='large' />
            </Form.Item> */}

            <div style={{ textAlign: 'right' }}>
                <Button onClick={onCancel} style={{ marginRight: 8 }} size='large'>
                    Cancel
                </Button>
                <Button type="primary" htmlType="submit" size='large'>
                    {initialValues ? 'Update' : 'Add'}
                </Button>
                {messagecontxt}
            </div>
        </Form>
    );
};

export default AddServiceType;
